import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CONFIG} from './../../config/app-config';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-account-active-temp',
  templateUrl: './account-active-temp.component.html',
  styleUrls: ['./account-active-temp.component.scss']
})
export class AccountActiveTempComponent implements OnInit { message: any = '';
token: any = '';
subscription: Subscription;
routeSub: Subscription;
constructor(private http: HttpClient,
  private route: ActivatedRoute,
  private router: Router,
  private toastr: ToastrService) {
    
}

ngOnInit() {
  this.routeSub = this.route.params
    .subscribe(params => {
      this.token = params['token'];  
    });
  this.http.get < any > (CONFIG.patientActivateTempURL + this.token).
  pipe(first())
    .subscribe(
      (data: any) => {
        // if (data.meta.status_code == 201 && data.meta.message_code == 'INVALID_TOKEN') {
        //   this.toastr.error('Your token has invalid!');
        //   this.message='Your token has invalid!'
        // }          
        // if (data.meta.status_code == 201 && data.meta.message_code=='ACCOUNT_SUCCESSFULLY_ACTIVATED') {
        //   this.message='Your account has now been activated.';
        //   this.toastr.success(data.meta.message);
        //   setTimeout(()=>{
        //     this.router.navigate(['/login']);
        //   },5000);
        // }
        if (data.meta.status) {
          this.message = data.meta.message;
          this.toastr.success (data.meta.message);
          // setTimeout(()=>{
          //   this.router.navigate(['/login']);
          // },5000);
        } else {
          this.toastr.error (data.meta.message);
          this.message = data.meta.message;
        }
      } , error => {
        const data = error;
        if (data.meta.message_code === 'USER_DOESNT_EXIST') {
          this.toastr.error(data.meta.message);
          this.message = data.meta.message;
        }
        if (data.meta.message_code === 'USER_NOT_VERIFIED') {
          this.toastr.error(data.meta.message);
          this.message = data.meta.message;
        }
      });
}

}